import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('WorkflowDA', WorkflowDA);

    WorkflowDA.$inject = ['$q', 'CONF', 'Restangular', 'WorkflowProfile'];

    /**
     * Class de manipulation des données du workflow
     */

    /* @ngInject */
    function WorkflowDA($q, CONF, Restangular, WorkflowProfile) {
        var baseUrl = CONF.apiBaseUrl + '/v1/principals';
        var wrkfUrl = CONF.apiBaseUrl + '/v1/workflows';
        var exports = {
            getProfiles: getProfiles,
            getThreeWayReferences: getThreeWayReferences,
            getOrderEntryReferences: getOrderEntryReferences,
            getOrderWorkflowProfiles: getOrderWorkflowProfiles,
            getWorkflowProfilesByUser: getWorkflowProfilesByUser,
        };

        return exports;

        ////////////////
        function getProfiles(principalId) {
            var canceler = $q.defer();

            const result = Restangular.one(baseUrl, principalId)
                .oneUrl('fr')
                .oneUrl('workflow-profiles')
                .withHttpConfig({ 10000: canceler.promise })
                .getList()
                .then(profiles => {
                    return _.map(profiles, profile => {
                        return new WorkflowProfile(profile);
                    });
                });
            canceler.resolve();
            return result;
        }

        /* Récupérer la liste des références order workflow à partir de l'Id de la legalEntity */
        function getOrderWorkflowProfiles(legalEntityId) {
            var canceler = $q.defer();

            const result = Restangular.one(wrkfUrl)
                .oneUrl('fr')
                .oneUrl('profiles')
                .withHttpConfig({ 10000: canceler.promise })
                .customGET('', { legalEntityId: legalEntityId })
                .then(profiles => {
                    return _.map(profiles, profile => {
                        return new WorkflowProfile(profile);
                    });
                });
            canceler.resolve();
            return result;
        }

        /* Récupérer la liste des références order workflow à partir de l'Id de la legalEntity */
        function getWorkflowProfilesByUser(userLogin) {
            var canceler = $q.defer();

            const result = Restangular.one(wrkfUrl)
                .oneUrl('fr')
                .oneUrl('profiles')
                .oneUrl(userLogin)
                .withHttpConfig({ 10000: canceler.promise })
                .getList()
                .then(profiles => {
                    return _.map(profiles, profile => {
                        return new WorkflowProfile(profile);
                    });
                });
            canceler.resolve();
            return result;
        }

        /* Récupérer la liste des références workflow d'un DO à partir de l'Id métier du DO */
        function getThreeWayReferences(principalEid) {
            const result = Restangular.one(wrkfUrl, principalEid)
                .oneUrl('ThreeWayReferences')
                .getList()
                .then(references => {
                    return _.map(references, reference => {
                        return reference;
                    });
                });
            return result;
        }

        /* Récupérer la liste des références workflow d'un DO à partir de l'Id métier d'une communauté */
        function getOrderEntryReferences(communityEid) {
            const result = Restangular.one(wrkfUrl, communityEid)
                .oneUrl('orderEntryReferences')
                .getList()
                .then(references => {
                    return _.map(references, reference => {
                        return reference;
                    });
                });
            return result;
        }
    }
})();
